<h2 class="form-title">{{ titleName }}</h2>
<div *ngIf="loading">
  <app-loading-indicator></app-loading-indicator>
</div>
<form (ngSubmit)="onSubmit()">
  <div class="control">
    <label for="name">Name</label>
    <input class="form-control" type="text" id="name" name="name" [(ngModel)]="name" />
  </div>

  <div class="control">
    <label for="message">Message</label>
    <textarea
      class="form-control"
      id="message"
      rows="3"
      name="message"
      [(ngModel)]="message"
    ></textarea>
  </div>
<!-- 
  <div class="control">
    <label for="interval">Interval(in seconds)</label>
    <input class="form-control" type="number" id="interval" name="interval" [(ngModel)]="interval" />
  </div> -->
  <div class="control">
    <label for="selectedReminderDropdown">Reminder Type</label>
    <p-dropdown
      styleClass="w-100"
      appendTo="body"
      [options]="reminderOptions"
      [(ngModel)]="selectedReminderOption"
      name="selectedReminderDropdown"
      id="selectedReminderDropdown"
      placeholder="Select a reminder type"
      [filter]="true"
      filterBy="label"
      optionLabel="label"
      optionValue="value"
      [virtualScroll]="true"
      [virtualScrollItemSize]="40"
      (onChange)="changedReminderType($event)"
    >
    
      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div class="flex align-items-center gap-2">
          <div>{{ selectedOption.label }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
  <div class="row mb-2 mt-3">
    @if (showDayOptions) {
      <div class="control col-4">
        <label>What days?</label>
        <div class="day-check-item">
          <p-checkbox
            type="checkbox"
            id="select-day-monday"
            class="day-check-item"
            name="Monday"
            [binary]="true"
            [(ngModel)]="monday"
            ></p-checkbox>
          <label for="select-day-monday" class="ms-2">Monday</label>
        </div>
        <div class="day-check-item">
          <p-checkbox
            type="checkbox"
            id="select-day-tuesday"
            class="day-check-item"
            name="Tuesday"
            [binary]="true"
            [(ngModel)]="tuesday"
            ></p-checkbox>
          <label for="select-day-tuesday" class="ms-2">Tuesday</label>
        </div>
        <div class="day-check-item">
          <p-checkbox
            type="checkbox"
            id="select-day-wednesday"
            class="day-check-item"
            name="wednesday"
            [binary]="true"
            [(ngModel)]="wednesday"
            ></p-checkbox>
          <label for="select-day-wednesday" class="ms-2">Wednesday</label>
        </div>
        <div class="day-check-item">
          <p-checkbox
            type="checkbox"
            id="select-day-thursday"
            class="day-check-item"
            name="thursday"
            [binary]="true"
            [(ngModel)]="thursday"
            ></p-checkbox>
          <label for="select-day-thursday" class="ms-2">Thursday</label>
        </div>
        <div class="day-check-item">
          <p-checkbox
            type="checkbox"
            id="select-day-friday"
            class="day-check-item"
            name="friday"
            [binary]="true"
            [(ngModel)]="friday"
            ></p-checkbox>
          <label for="select-day-friday" class="ms-2">Friday</label>
        </div>
        <div class="day-check-item">
          <p-checkbox
            type="checkbox"
            id="select-day-saturday"
            class="day-check-item"
            name="saturday"
            [binary]="true"
            [(ngModel)]="saturday"
            ></p-checkbox>
          <label for="select-day-saturday" class="ms-2">Saturday</label>
        </div>
        <div class="day-check-item">
          <p-checkbox
            type="checkbox"
            id="select-day-sunday"
            class="day-check-item"
            name="sunday"
            [binary]="true"
            [(ngModel)]="sunday"
            ></p-checkbox>
          <label for="select-day-sunday" class="ms-2">Sunday</label>
        </div>
      </div>
    }
    <div class="m-0 p-0" [ngClass]="{ 'col-8': showDayOptions == true, 'col-12': !showDayOptions }">
      <div class="row d-flex flex-column w-100 m-0 p-0 ">
        @if (showWeekOptions) {
          <div class="col-12 m-0 p-0 control">  
            <label for="selectedWeekDropdown">Week of the Month</label>
            <p-dropdown
              styleClass="w-100"
              appendTo="body"
              [options]="weekOptions"
              [(ngModel)]="weekOfMonth"
              name="selectedWeekDropdown"
              id="selectedWeekDropdown"
              placeholder="Select which week of the month to show reminder"
              [filter]="true"
              filterBy="label"
              optionLabel="label"
              optionValue="value"
              [virtualScroll]="true"
              [virtualScrollItemSize]="40"
              (onChange)="changedWeekType($event)"
            >
            
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        }
        <div class="col-12 m-0 p-0 control">
          <label for="reminderTime">Reminder Time</label>
            <p-calendar id="reminderTime" [dateFormat]="'dd/MM/YYYY HH:mm aa'" name="reminderTime" [timeOnly]="true" [hourFormat]="'12'" [(ngModel)]="Time" (onBlur)="testCalendar(Time)" placeholder="hh:mm"></p-calendar>
        </div>
        <div class="col-12 m-0 p-0 control">
          <div class="day-check-item mt-1 pt-1">
            <p-checkbox
            type="checkbox"
            id="repeatReminder"
            class="day-check-item"
            name="RepeatReminder"
            value="doRepeat"
            [binary]="true"
            [(ngModel)]="doRepeat"
            (onChange)="toggleInterval()"
            ></p-checkbox>
            <label
            for="repeatReminder"
            class="ms-2 progress-note-section-content-item-label"
            >Repeat the reminder in intervals</label>
          </div>
          <div class="row m-0 p-0 control" *ngIf="showInterval">
              <label for="interval">Interval (in Minutes)</label>
              <input class="form-control" type="number" id="interval" name="interval" [(ngModel)]="interval" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button type="button" (click)="onCancel()">Cancel</button>
    <button type="submit">{{ actionName }}</button>
  </div>
</form>
